// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1WebhookSchema } from './v1/webhookSchema';

export const showWebhookPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Webhook ID"),
});

export const showWebhookHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Webhook details
 */
export const showWebhook200Schema = z.lazy(() => v1WebhookSchema);

/**
 * @description Unauthorized
 */
export const showWebhook401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Webhook not found
 */
export const showWebhook404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const showWebhookQueryResponseSchema = z.lazy(() => showWebhook200Schema);
